"use strict";

import angular from "angular";

import template from "./sidenav-form.component.html";
import "./sidenav-form.component.scss";

/**
 * A casca do painel lateral de formulário: cabeçalho, barra de progresso e o corpo onde o
 * formulário é montado.
 *
 * O conteúdo é compilado à mão, e não por `ng-include`, porque cada formulário traz o seu
 * próprio controller -- é o mesmo serviço que o `$mdDialog` presta, só que dentro de um
 * `md-sidenav`. O controller recebe `locals` e um `$mdDialog` de fachada, então templates e
 * controllers que vieram do diálogo continuam valendo sem edição.
 *
 * Basta um por tela: o serviço guarda um formulário aberto por vez.
 */
class DesnuSidenavFormComponent {
    constructor(
        $scope,
        $element,
        $compile,
        $controller,
        DesnuSidenavFormService
    ) {
        this.$scope = $scope;
        this.$element = $element;
        this.$compile = $compile;
        this.$controller = $controller;
        this.service = DesnuSidenavFormService;
        this.instance = null;
        this._contentScope = null;
    }

    $onInit() {
        this.$scope.$watch(
            () => this.service.config?.token,
            () => this._render()
        );
        this.$scope.$on("$destroy", () => this._destroyContent());
    }

    width() {
        return this.service.config?.width || "720px";
    }

    onClose() {
        this.service.cancel();
    }

    _render() {
        this._destroyContent();

        const config = this.service.config;
        if (!config) return;

        const scope = this.$scope.$new();
        const instance = this.$controller(config.controller, {
            $scope: scope,
            $mdDialog: this.service.dialogFacade,
            locals: config.locals
        });

        scope[config.controllerAs] = instance;
        this._contentScope = scope;
        this.instance = instance;

        // Mesma ordem do `$mdCompiler`: expor no escopo, chamar o `$onInit` e só então linkar
        // o template. Controller instanciado à mão não recebe o hook de ninguém -- e é nele
        // que os formulários de contabilidade carregam os dados. Sem esta chamada, o painel
        // de editar abria com todos os campos vazios.
        if (angular.isFunction(instance.$onInit)) instance.$onInit();

        this._body().append(this.$compile(config.templateHtml)(scope));
    }

    _destroyContent() {
        if (this._contentScope) {
            this._contentScope.$destroy();
            this._contentScope = null;
        }
        this.instance = null;
        this._body().empty();
    }

    _body() {
        return angular.element(
            this.$element[0].querySelector("#DesnuSidenavFormBody")
        );
    }
}

DesnuSidenavFormComponent.$inject = [
    "$scope",
    "$element",
    "$compile",
    "$controller",
    "DesnuSidenavFormService"
];

export { DesnuSidenavFormComponent };

const name = "desnuSidenavFormComponent";
const def = {
    bindings: {},
    controller: DesnuSidenavFormComponent,
    template
};
angular.module("nucont.shared").component(name, def);
export default { name, ...def };
